<template>
  <button
      class="btn"
      :class="{
         'warning': type === 'warning',
         'ok': type === 'ok',
         'default': type === 'default'
       }"
      :disabled="disabled"
      @click="$emit('onClick')"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  name: 'AppBtn',
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'default' // 'warning' 'ok'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style scoped>

.btn {
  display: block;
  padding: 0 15px;
  border-radius: 7px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: none;
  transition: .3s;
  line-height: 33px;
  text-transform: uppercase;
  font-size: 15px;
}

.default {
  border: 1px solid #2b48a6;
  background: #4371e7;
  color: white;
}
.default:hover, .default:focus {
  background: #859ae8;
}
.default:active {
  background: #2b48a6;
}
.default:disabled {
  cursor: not-allowed;
  background: #425383;
}

.ok {
  border: 1px solid #4ca54c;
  background: #36da36;
  color: white;
}
.ok:hover, .ok:focus {
  background: #82d382;
}
.ok:active {
  background: #3a883a;
}
.ok:disabled {
  cursor: not-allowed;
  background: #b4ccb4;
}


.warning {
  background: #ea7777;
  border: 1px solid red;
  color: #fff;
}
.warning:hover, .warning:focus {
  background: #f54d4d;
}
.warning:active {
  background: #c45454;
}
.default:disabled {
  cursor: not-allowed;
  background: #9d6363;
}

</style>